import axios from 'axios';
import { TKeys } from '@/i18n/useTranslate';
import { getError } from '@/store/common/error-handlers';
import { errorToast } from '@/components/Toast';
import { ValidationErrorType } from '@/types/ValidationError';
import { getTranslate } from '@/i18n/getTranslate.ts';

const showValidationErrorToast = async (
  str: TKeys<'common' | 'validationErrors'>
) => {
  const t = await getTranslate('validationErrors');
  void errorToast({ description: t(str) });
};
export const showError500OrUnknownToast = (
  e: unknown,
  text?: TKeys<'common'>
) => {
  if (import.meta.env.MODE !== 'production') {
    console.error('ERROR', e, text);
  }

  if (axios.isAxiosError(e) && e.response?.status === 500) {
    void showValidationErrorToast(ValidationErrorType.Error_500);
    return;
  }
  if (axios.isAxiosError(e) && e.response?.status === 401) {
    return;
  }
  const err = getError(e);
  void showValidationErrorToast(
    err === ValidationErrorType.UNKNOWN_ERROR && text ? text : err
  );
};
